export default __webpack_public_path__ + "static/media/four-digits-white.65d8174e.svg";